<div class="disabled-overlay" *ngIf="processing">
  <div>
    <div class="spinner" [re-center-in-container]>
      <div class="lspinner"></div>
    </div>
  </div>
</div>
<re-maintenance-info-banner></re-maintenance-info-banner>
 

<ng-container *ngIf="showMenu">
    <re-primary-nav [isAuthenticated]="isAuthenticated" *ngIf="isAuthenticated || nav.forgot"></re-primary-nav>
</ng-container>

<div class="container-fluid user-logged-in">
  <div #genericFloatingAlert style="white-space: pre-line;" class="alert floating mt-2" [ngClass]="alertClass" role="alert" *ngIf="alert">
    <i class="alert-close" (click)="alert=null" aria-hidden="true"></i>
    {{ alert.message }}
  </div>
</div>


<div *ngIf="nav.forgot">
  <main>
    <div class="container-fluid user-logged-in">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<div *ngIf="!nav.forgot">
  <main>
    <div [class]="isAuthenticated ? 'container-fluid user-logged-in' : 'user-logged-off'">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<re-primary-footer *ngIf="isAuthenticated"></re-primary-footer>

